import React, { FC } from 'react';

export const Information: FC = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" {...props}>
    <circle cx="12" cy="12" r="12" fill="#02315B" />
    <path
      fill="#fff"
      d="M11.34 7.94c.229.198.494.296.797.296.293 0 .551-.098.776-.3.225-.2.337-.472.337-.823A1.091 1.091 0 0 0 12.137 6c-.317 0-.589.106-.807.32-.221.214-.33.48-.33.793 0 .354.112.63.34.827Z"
    />
    <rect width="2.25" height="8.25" x="11" y="9.75" fill="#fff" rx="1.125" />
  </svg>
);
